export interface IntercomState {
  requestForTestersHasSent: boolean;
  app_id: string;
  user_id?: string;
  language_override?: string;
}

const initialState: IntercomState = {
  requestForTestersHasSent: false,
  app_id: 'rolopgu5',
}

export default initialState
